import './index.css';

function cardInfo({name_card, info, icon}){
  return (
    <>
      <div className="card_info">
        <div className="name_card">
          {name_card}
        </div>
        <div className="info">{info}</div>
        <div className="icon">
          <img src='./dashboard/Ellipse 27.svg'alt="" />
          <img className='img_icon' src={icon}></img>
        </div>
      </div>
    </>
  );
}

export default cardInfo;